import { render, staticRenderFns } from "./GJgrowEventCreateTerm.vue?vue&type=template&id=15182bec&scoped=true&"
import script from "./GJgrowEventCreateTerm.vue?vue&type=script&lang=ts&"
export * from "./GJgrowEventCreateTerm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15182bec",
  null
  
)

export default component.exports